import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams, HttpErrorResponse } from "@angular/common/http";
import { Label, CacheService } from "mapfre-auditlib";
import { Observable, of, Subject } from "rxjs";
import moment from 'moment';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Router } from '@angular/router';

@Injectable({
   providedIn: "root"
})
export class LabelService {

   className = 'LabelService';

   memoryCache = {
      "labels": {
         "data": null,
         "lastReqDate": null
      }
   }

   constructor(private http: HttpClient, private cacheService: CacheService, private router: Router) { }

   getAllLabels(showJob = true, showRdn = true): Observable<Label[]> | any  {
      let cache = true;
      let params: any = {};
      params.showJob = showJob;
      params.showRdn = showRdn;

      let cacheKey = "labels"+"_"+showJob.toString()+"_"+showRdn.toString();

      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
      } else {
         let observable = this.http.get<any[]>(environment.base_URL + "/tags", { params }).pipe(map((res) => {
            this.cacheService.updateCacheData(res, cacheKey)
            return res;         
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
      }
   }

   getLabelById(id): Observable<Label> {
      return this.http.get<Label>(environment.base_URL + `/tags/${id}`)
   }

   newLabel(label) {
      return this.http.post(environment.base_URL + "/tags", label)
   }

   updateLabel(label, id) {
      return this.http.put(environment.base_URL + `/tags/${id}`, label)
   }

   deleteLabel(id: Number) {
      return this.http.delete(environment.base_URL + `/tags/${id}`)
   }

   createTranslation(translation, tagId) {
      //Idlanguage & txtValor
      return this.http.post(environment.base_URL + `/tags/translations/${tagId}`, translation)
   }
   updateTranslation(label, relationId) {
      return this.http.put(environment.base_URL + `/tag-translations/${relationId}`, label)
   }
   deleteTranslation(relationId: Number) {
      return this.http.delete(environment.base_URL + `/tag-translations/${relationId}`)
   }


   /**
    * Delete Cache
    */

   deleteCache() {

      let memoryCache = ["labels"];

      _.forEach(memoryCache, item => {
         this.cacheService.deleteCache(item);
      })

   }

}
